import type { ComponentInternalInstance } from 'vue';
import type { Matomo } from '@/plugins/matomo';

export default (
  currentInstance: ComponentInternalInstance | null | undefined,
): Matomo | undefined =>
  (currentInstance?.appContext.config.globalProperties.$matomo || undefined) as
    | Matomo
    | undefined;
